// Load jQuery
import { FormUtilities, SiteUtilities } from './utils';
import Submit from './form-submit-handlers';

const emailOnlySubmitHandlerNames = {
  fcaller: 'fcallerSignupForm',
  fteam: 'fteamSignupForm',
  fdesk: 'fdeskEmailOnlySignupForm',
  fchat: 'fchatSignupForm',
  fmarketer: 'fmarketerSignupForm',
  fservice: 'fserviceEmailOnlySignupForm',
  frelease: 'freleaseSignupForm',
  mtgap: 'mtgapSubscribeForm',
  fthoughts: 'fthoughtsSubscribeForm',
  c4l: 'c4lSubscribeForm'
};
const jobDescriptionSubmitHandlerNames = {
  fteam: 'jobDescriptionForm'
};
// const demoRequestHandlers = {
//   fservice: 'fserviceDemoRequestForm',
//   fchat: 'fchatDemoRequestForm'
// };

// const demoRequestCalendlyHandlers = {
//   fdesk: 'fdeskDemoRequestForm',
//   fteam: 'fteamDemoRequestForm'
// };

const whitepaperTemplateHandlers = {
  whitepaper: 'whitepaperForm',
  'fdesk-features-list': 'fdeskFeaturesListForm',
  'fdesk-gartner-magic-quadrant-form': 'fdeskGartnerMagicQuadrantForm'
};

const loginFormHandlers = {
  fsales: 'fwcrmLoginForm',
  fcaller: 'fcallerLoginForm',
  fchat: 'fchatLoginForm',
  fdesk: 'fdeskLoginForm',
  fteam: 'fteamLoginForm',
  fstatus: 'fstatusLoginForm',
  fmarketer: 'fmarketerLoginForm',
  fping: 'fpingLoginForm',
  fconnect: 'fconnectLoginForm',
  fservice: 'fserviceLoginForm',
  fwcrm: 'fwcrmLoginForm',
  fsurvey: 'fsurveyLoginForm',
  fwcssuite: 'fwcssuiteLoginForm'
};

const forgotDomainHandlers = {
  fsales: 'fwcrmForgotDomainForm',
  fcaller: 'fcallerForgotDomainForm',
  fchat: 'fchatForgotDomainForm',
  fdesk: 'fdeskForgotDomainForm',
  fteam: 'fteamForgotDomainForm',
  fstatus: 'fstatusForgotDomainForm',
  fmarketer: 'fmarketerForgotDomainForm',
  fping: 'fpingForgotDomainForm',
  fconnect: 'fconnectForgotDomainForm',
  fservice: 'fserviceForgotDomainForm',
  fwcrm: 'fwcrmForgotDomainForm',
  fsurvey: 'fsurveyForgotDomainForm',
  fwcssuite: 'fwcssuiteForgotDomainForm'
};

// for fchat custom quote form, we're using the same
// submit handler as fchat demo request form since the
// flow is similar
const customQuoteHandlers = {
  fchat: 'fchatDemoRequestForm'
};

// fetch the current Scope
const product = jQuery('body').data('product-name');

// Load the dotdotdot ellipsis plugin
const ellipsisLoader = () => {
  // Below jquery plugin dotdotdot gets triggered
  if (jQuery('.ellipsis-wrapper').length) {
    SiteUtilities.onModuleLoad('lib/ellipsis').then(() => {
      jQuery('.ellipsis-wrapper').dotdotdot();
      jQuery(window).on('resize', () => {
        jQuery('.ellipsis-wrapper').trigger('update.dot');
      });
    });
  }
};

const initHTML5Video = () => {
  var videoStatus = {};
  jQuery('.video-placeholder-image').on('click', function () {
    $(this).addClass('hide');
    this.previousElementSibling.play();
  });
  jQuery('.feature-video-box .play-button').each(function (index) {
    var playButton = this;
    var placeholderImage = $(this).siblings('.video-placeholder-image');
    var video = this.nextElementSibling;
    videoStatus[video.id] = 'paused';
    var playPauseToggle = function () {
      if (videoStatus[video.id] === 'paused') {
        video.play();
      } else {
        video.pause();
      }
    };
    video.onclick = playPauseToggle;
    playButton.onclick = playPauseToggle;
    video.onplay = function () {
      if (!$(placeholderImage).hasClass('hide')) {
        $(placeholderImage).addClass('hide');
      }
      $(playButton).hide();
      videoStatus[video.id] = 'playing';
    };
    video.onpause = function () {
      $(playButton).show();
      videoStatus[video.id] = 'paused';
    };
  });
};

// load email only signup code
const emailOnlySignupLoader = () => {
  if (jQuery('.email-only-signup').length > 0) {
    const proxySubmitHandler = function (className, form) {
      const formProduct = $(form).data('product');
      const productName = formProduct || product;
      let currentProduct;
      if (formProduct && emailOnlySubmitHandlerNames[formProduct]) {
        currentProduct = emailOnlySubmitHandlerNames[formProduct];
      } else {
        currentProduct = emailOnlySubmitHandlerNames[product];
      }

      if ($(form).data('signup-version') === 'v2' && productName !== 'fdesk') {
        currentProduct = 'alohaForm';
      }
      Submit[currentProduct].apply('', arguments);
    };
    FormUtilities.validation('email-only-signup', 'email-field', proxySubmitHandler);
  }
};

const autoFillForms = () => {
  try {
    const userDetails = JSON.parse(localStorage.getItem('form_details'));
    if (userDetails !== null) {
      const $forms = jQuery('form');
      for (var i = 0; i < $forms.length; i++) {
        const $form = jQuery($forms[i]);
        const keys = Object.keys(userDetails);
        for (var j = 0; j < keys.length; j++) {
          let $item;
          if (keys[j] === 'email') {
            $item = $form.find('input[type="email"]') || $form.find('input[name*="email"]');
          } else if (['query-department', 'query-job-level', 'query-company-industry'].includes(keys[j])) {
            $item = $form.find(`select[name*=${keys[j]}]`);
          } else {
            $item = $form.find(`input[name*=${keys[j]}]`);
          }

          if ($item) {
            if ($item.prop('tagName') === 'SELECT') {
              if ($item.find(`option[value="${userDetails[keys[j]]}"]`).length) {
                $item.find(`option[value="${userDetails[keys[j]]}"]`).attr('selected', 'selected');
                $item.addClass('field-fix').siblings('.form-placeholder').addClass('placeholder-fix');
                setTimeout(function () { $item.trigger('change'); });
              }
            } else {
              if ($item.attr('data-disable-prefill') !== 'true') {
                $item.val(userDetails[keys[j]]).addClass('field-fix');
                $item.siblings('.form-placeholder').addClass('placeholder-fix');
                SiteUtilities.additionalGenericFields($item, $form);
              }
            }
          }
        }
      }
    }
  } catch (e) {
    SiteUtilities.log(
      'Auto populating form fields Fail',
      'Error',
      'Plugin loaders - autoFillForms',
      1,
      e
    );
  }
};

// fteam job-description-bundle-signup
const jobDescriptionSignupLoader = () => {
  if (jQuery('.job-description-bundle-signup').length > 0) {
    const currentProduct = jobDescriptionSubmitHandlerNames[product];
    FormUtilities.validation('job-description-bundle-signup', 'email-field', Submit[currentProduct]);
  }
};

// // load request demo form code
// const demoRequestFormLoader = () => {
//   var productName = jQuery('body').data('product-name');
//   if (jQuery('.' + productName + '-demo-request-form').length > 0) {
//     let demoRequestHandler = demoRequestHandlers[productName];
//     FormUtilities.validation(productName + '-demo-request-form', 'form-field', Submit[demoRequestHandler]);
//   }
// };

// const demoRequestCalendlyLoader = () => {
//   var productName = jQuery('body').data('product-name');
//   if (jQuery('.' + productName + '-demo-calendly-form').length > 0) {
//     let demoRequestHandler = demoRequestCalendlyHandlers[productName];
//     FormUtilities.validation(productName + '-demo-calendly-form', 'form-field', Submit[demoRequestHandler]);
//   } else if (jQuery('.calendly-only').length > 0) {
//     let calendlyScriptTag = document.createElement('script');
//     let dataUrl = jQuery("input[name='calendlyUrl']").val();
//     calendlyScriptTag.src = 'https://calendly.com/assets/external/widget.js';
//     if (productName === 'fsales') {
//       dataUrl = dataUrl.replace(/{{location}}/i, locationData.countryName);
//     }
//     jQuery('.calendly-inline-widget').attr('data-url', dataUrl);
//     jQuery('.calendly-data-container').append(calendlyScriptTag);
//   }
// };

// load appropriate form in whitepaper template
const whitepaperTemplateFormLoader = () => {
  if (jQuery('.' + product + '-whitepaper-form').length > 0) {
    const whitepaperHandler = whitepaperTemplateHandlers['whitepaper'];
    FormUtilities.validation(product + '-whitepaper-form', 'form-field', Submit[whitepaperHandler]);
  }
  if (jQuery('.' + product + '-features-list-form').length > 0) {
    const whitepaperHandler = whitepaperTemplateHandlers[`${product}-features-list`];
    FormUtilities.validation(product + '-features-list-form', 'form-field', Submit[whitepaperHandler]);
  }
  if (jQuery('.' + product + '-gartner-magic-quadrant-form').length > 0) {
    const whitepaperHandler = whitepaperTemplateHandlers[`${product}-gartner-magic-quadrant-form`];
    FormUtilities.validation(product + '-gartner-magic-quadrant-form', 'form-field', Submit[whitepaperHandler]);
  }
};

// load login  form code
const loginFormLoader = () => {
  if (jQuery('#' + product + '_login_form').length > 0) {
    const loginFormHandler = loginFormHandlers[product];
    FormUtilities.validation(product + '-login', 'form-field', Submit[loginFormHandler]);
  }
};

// load login  form code
const forgotDomainFormLoader = () => {
  if (jQuery('#forgot_domain_form').length > 0) {
    const forgotDomainFormHandler = forgotDomainHandlers[product];
    FormUtilities.validation('forgot-domain', 'form-field', Submit[forgotDomainFormHandler]);
  }
};

// load custom quote form
const customQuoteFormLoader = () => {
  if (jQuery('.' + product + '-custom-quote-form').length > 0) {
    const customQuoteHandler = customQuoteHandlers[product];
    FormUtilities.validation(product + '-custom-quote-form', 'form-field', Submit[customQuoteHandler]);
  }
};

// Load the bodymovin plugin
const bodymovinLoader = () => {
  $('[data-bodymovin-container]').length && SiteUtilities.onModuleLoad('lib/bodymovin');
};

const init = () => {
  ellipsisLoader();
  emailOnlySignupLoader();
  jobDescriptionSignupLoader();
  loginFormLoader();
  whitepaperTemplateFormLoader();
  forgotDomainFormLoader();
  customQuoteFormLoader();
  bodymovinLoader();
  initHTML5Video();
  autoFillForms();
};

export default { init };
